import { motion } from "framer-motion";
import { ShieldCheck, MapPin, Lock, Headphones } from "lucide-react";
import "../style/UKBusinessStyle.css";

const UKBusinessesSection = () => {
    const fadeInUp = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0 }
    };

    const features = [
        {
            icon: <ShieldCheck size={48} strokeWidth={2} />,
            title: "GDPR Compliant",
            description: "Your data is safeguarded in line with EU data protection standards, using encrypted storage, secure authentication, and regular backups."
        },
        {
            icon: <MapPin size={48} strokeWidth={2} />,
            title: "UK Based",
            description: "Built with UK businesses in mind, featuring built-in VAT calculations, QuickBooks UK & Xero integration, GBP pricing, and British date formats."
        },
        {
            icon: <Lock size={48} strokeWidth={2} />,
            title: "Security",
            description: "Your data is protected with enterprise-grade security, including encryption in transit and at rest, secure Stripe payments, regular security updates, and daily automated backups."
        },
        {
            icon: <Headphones size={48} strokeWidth={2} />,
            title: "UK Support",
            description: "Get email support from people who understand how UK mobile service businesses and contractors operate. Feature requests are welcomed and frequently delivered at no additional charge."
        }
    ];

    return (
        <section className="uk-businesses-section">
            <div className="container">
                <motion.div
                    className="text-center mb-5"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={{
                        visible: {
                            transition: {
                                staggerChildren: 0.15
                            }
                        }
                    }}
                >
                    <motion.h2
                        className="uk-section-title"
                        variants={fadeInUp}
                    >
                        Built for UK Businesses
                    </motion.h2>
                    <motion.p
                        className="uk-section-subtitle"
                        variants={fadeInUp}
                    >
                        Enterprise-grade software, professionally built for mobile service businesses and contractors.
                    </motion.p>
                </motion.div>

                <motion.div
                    className="row g-4"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={{
                        visible: {
                            transition: {
                                staggerChildren: 0.2
                            }
                        }
                    }}
                >
                    {features.map((feature, index) => (
                        <motion.div
                            key={index}
                            className="col-12 col-md-6"
                            variants={fadeInUp}
                        >
                            <div className="uk-feature-card">
                                <div className="uk-feature-icon">
                                    {feature.icon}
                                </div>
                                <div className="uk-feature-content">
                                    <h3 className="uk-feature-title">{feature.title}</h3>
                                    <p className="uk-feature-description">{feature.description}</p>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default UKBusinessesSection;